/** ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * MODULE: main.js
 * Author: SE EMK
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* -------------------------------- Imports --------------------------------- */
/* Basic */
import Vue from 'vue'
import App from './App.vue'

/* Router */
import router from './router'
import { sync } from 'vuex-router-sync'

/* Store */
import store from '@/store/store'

/* Plugins and global components */
import fontawesome from '@fortawesome/fontawesome'
import solid from '@fortawesome/fontawesome-free-solid'
import regular from '@fortawesome/fontawesome-free-regular'
import brands from '@fortawesome/fontawesome-free-brands'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import VueMarkdown from 'vue-markdown'
/* ------------------------------ Definitions ------------------------------- */
/* ------------------------------- Functions -------------------------------- */
/* --------------------------------- Body ----------------------------------- */
/* -------------------------------- Exports --------------------------------- */
/* Require the main Sass manifest file */
require('./assets/sass/main.scss')

/* Plugins */
/* Add fontawesome */
fontawesome.library.add(solid, regular, brands)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('markdown', VueMarkdown)

/* Set config */
Vue.config.productionTip = false

/* Router store sync */
sync(store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js